import React from 'react';
import { Legend } from 'react-timeseries-charts';
import { legendStyle, legendLabelStyle } from './styles';
import { getCategories } from './i18n';

export default function ObservedLegend({ classes, lang, currentTech }) {
  const { observedCategories } = getCategories(lang, currentTech);
  return (
    <Legend
      type="line"
      align="left"
      stack={true}
      style={legendStyle}
      labelStyle={legendLabelStyle}
      categories={observedCategories}
      className={classes.timeplotLegend}
    />
  );
}
